export default __webpack_public_path__ + "static/media/squad_bee_image.99304dc7.png";